module.exports = __webpack_public_path__ + "img/add-company.431ffc2c.svg";